import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="8" height="13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7 1.21a.996.996 0 00-1.41 0L1 5.8a.996.996 0 000 1.41l4.59 4.59A.996.996 0 107 10.39L3.12 6.5 7 2.62c.39-.39.38-1.03 0-1.41z" fill="#07A" /></svg>;